module.exports = __webpack_public_path__ + "img/round-more_horiz-24px.664662ef.svg";